module.exports = __webpack_public_path__ + "img/property-guard.304c7b06.png";